export enum CreatePasskeyMessageType {
  SUCCESS = 'WEBAUTHN_CREATE_PASSKEY_SUCCESS',
  ERROR = 'WEBAUTHN_CREATE_PASSKEY_ERROR',
  CANCELLED = 'WEBAUTHN_CREATE_PASSKEY_CANCELLED',
}

export enum CreatePasskeyErrorCode {
  CANCELLED = 'CANCELLED',
  TIMEOUT = 'TIMEOUT',
  DUPLICATE_PASSKEY = 'DUPLICATE_PASSKEY',
  // Browser/device has no usable WebAuthn API (feature detection failed).
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  // The server rejected the submitted credential as incorrect enrollment data
  // (INCORRECT_ENROLLMENT_DATA) — typically an interfering browser extension
  // producing a malformed credential.
  CREDENTIAL_NOT_SUPPORTED = 'CREDENTIAL_NOT_SUPPORTED',
  // The enroll call still requires step-up authentication (RFC 9470) even with
  // the handed-off Bearer token. The popup posts this back and account-settings
  // shows a dedicated snackbar; there is no retry or password fallback.
  STEP_UP_REQUIRED = 'STEP_UP_REQUIRED',
  GENERAL = 'GENERAL',
}

export interface CreatePasskeyMessage {
  type: CreatePasskeyMessageType;
  requestId?: string;
  data?: Record<string, unknown>;
  errorCode?: CreatePasskeyErrorCode;
}
